import initSharedCartItems from '../shared/initSharedCartItems';
import AnalyticsService from '../../analytics/AnalyticsService';

window.tnew.page.initialize = (pageConfig) => {
  initSharedCartItems(pageConfig);

  AnalyticsService.pushEcommerceItems(pageConfig.ga4DatalayerItems);
};
